import httpHelper from "@/helpers/httpHelper";
// action types 
export const GET_USER_LIST = "getUserList";
// mutation types
export const SET_USER_LIST = "setUserList";

export default {
    state: {
        UserList: {},

    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedUserList(state) {
            return state.UserList;
        },


    },
    actions: {
        /**
         * Set the BankList 
         * @param state
         * @param payload
         */
        [GET_USER_LIST](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData('accounters-report/'+payload)
                    .then((response) => {
                       if(response.success){
                        context.commit(SET_USER_LIST, response.result);
                        resolve(response.result);
                    }
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
    mutations: {

        [SET_USER_LIST](state, payload) {
            state.UserList = payload;
        },

    }
};